import axios from 'axios'

// Use relative URL in production (same domain), absolute URL in development
const getBaseURL = () => {
  // If VITE_API_URL is explicitly set, use it
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  // Check if we're running on localhost (development)
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:3001/api'
  }

  // Otherwise use relative URL (production)
  return '/api'
}

export const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send cookies with requests
})

// Response interceptor for handling auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if we're in demo mode - don't redirect if so
      const searchParams = new URLSearchParams(window.location.search)
      const isDemoMode = searchParams.get('demo') === 'true'

      if (isDemoMode) {
        console.log('[API Interceptor] Demo mode active - ignoring 401 error')
        return Promise.reject(error)
      }

      // Session expired or invalid - redirect to login (only if not in demo mode)
      // Don't redirect on public pages: login, register, home, blog
      const currentPath = window.location.pathname
      const isPublicPage = currentPath === '/login' ||
                           currentPath === '/register' ||
                           currentPath === '/' ||
                           currentPath.startsWith('/blog')
      if (!isPublicPage) {
        console.log('[API Interceptor] 401 error - redirecting to login')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)